import { NavLink } from 'react-router-dom';

export interface SectionTab {
  to: string;
  label: string;
  end?: boolean;
}

/** Tab lists stay owned by features; this component supplies shared navigation styling. */
export function SectionTabs({
  items,
  label,
}: {
  items: readonly SectionTab[];
  label: string;
}) {
  return (
    <nav
      aria-label={label}
      className="flex min-w-0 max-w-full flex-nowrap gap-1 overflow-x-auto border-b border-line"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `flex min-h-11 shrink-0 items-center whitespace-nowrap border-b-2 px-3 py-2 text-sm-label font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ink ${isActive ? 'border-primary text-primary' : 'border-transparent text-ink-2 hover:bg-bg-warm hover:text-ink'}`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
